import cityPlaceholderImg from '@/../img/placeholders/city-placeholder.jpg';
import { signS3Url } from '@/utils/sign-s3-url';
import { useEffect, useRef, useState } from 'react';

interface Props {
  alt: string;
  src: string;
  isContentHidden?: boolean;
}

export function S3Img(props: Props) {
  const imgRef = useRef<HTMLImageElement>(null);
  const [resolvedSrc, setResolvedSrc] = useState<string>(cityPlaceholderImg);

  useEffect(() => {
    if (props.isContentHidden) return;

    (async function signUrl() {
      const signedUrl = await signS3Url(props.src);
      if (imgRef.current) setResolvedSrc(signedUrl ?? cityPlaceholderImg);
    })();
  }, [props.isContentHidden, props.src]);

  return <img ref={imgRef} alt={props.alt} src={resolvedSrc} />;
}
